<template>
  <div style="display: inline-block">
    <!-- select使用dropdown组件完成下拉框，针对多种场景需要不同的配置 -->
    <sj-dropdown
      ref="dropdown"
      :dropdownClass="
        `select_${type}${colorNormal ? ' select_color_normal' : ''}`
      "
      placement="bottom-start"
      :trigger="trigger"
      :arrow="arrow"
      @show="handleDropdownShow"
      @hide="handleDropdownHide"
      :boundariesSelector="boundariesSelector"
      :appendToBody="appendToBody"
      :arrowVisible="arrowVisible"
    >
      <!-- select的input数据显示部分 -->
      <div
        class="select-input"
        slot="reference"
        @mouseenter="handleInputEnter"
        @mouseleave="handleInputLeave"
        :class="[`select-size-${size}`]"
      >
        <!-- 禁用状态屏蔽操作的遮罩 -->
        <div class="select-cover" v-if="disabled" @click.stop></div>
        <!-- 多选select时使用tag展示数据 -->
        <div
          class="select-tag-list"
          style="cursor: pointer;"
          v-if="multiple && selectedOptions.length > 0"
        >
          <!-- <SjTag class="select-tag-item" closable @close="onMultiTagClose">
            {{ selectedOptions[0] && selectedOptions[0].label }}
          </SjTag>
          <SjTag class="select-tag-item" v-if="selectedOptions.length >= 2">
            +{{ selectedOptions.length - 1 }}
          </SjTag> -->
          <SjTag
            v-for="(selectedItem, index) in selectedOptions"
            :key="index"
            class="select-tag-item"
            :size="smallerSize"
            type="closeonly"
            theme="2"
            @close="onMultiTagClose(index)"
          >
            {{ selectedItem && selectedItem.label }}
          </SjTag>
        </div>
        <sj-tooltip
          v-if="
            selectedOptions[0] &&
              selectedOptions[0].tooltips &&
              selectedOptions[0].tooltipType !== 'simple'
          "
          placement="bottom"
          style="position: absolute;height: 16px;top: 0;bottom: 0;margin:auto;right: 40px; display: flex; align-items: center;"
        >
          <i
            slot="reference"
            :class="[
              'icon_com',
              selectedOptions[0].tipIcon
                ? selectedOptions[0].tipIcon
                : 'comselect_info'
            ]"
            style="vertical-align:super;"
          ></i>
          <div slot="tooltips" v-html="selectedOptions[0].tooltips"></div>
        </sj-tooltip>
        <!-- 单选使用input展示数据 -->
        <sj-input
          class="select-input-inner"
          :class="{ showClear }"
          :border="border"
          ref="sjInput"
          :size="size"
          :placeholder="placeholder"
          :padding="padding"
          :is-focus="isFocus"
          :is-error="isError"
          :title="
            toggled && filterable
              ? filterWord
              : !selectedOptions[0]
              ? null
              : multiple
              ? ' '
              : selectedOptions[0].label
          "
          :value="
            toggled && filterable
              ? filterWord
              : !selectedOptions[0]
              ? null
              : multiple
              ? ' '
              : selectedOptions[0].label
          "
          @input="handleFilterInput"
          @keyup.enter="handleKeyupEnter"
          :disabled="disabled"
          :readonly="toggled && filterable ? false : true"
          cursor="pointer"
        ></sj-input>
        <SjIcon
          class="select-close-icon"
          v-if="showClear"
          iconClass="commulti_close"
          :size="24"
          :iconSize="12"
          @click.native="handleClear"
        />
        <i
          :class="[
            'select-arrow2',
            'icon_com',
            'comselect_expand',
            toggled ? 'select-arrow-show' : 'select-arrow-hide',
            {
              disabled
            }
          ]"
          @mousedown="handleMousedown"
          @click="handleOpen"
        ></i>
      </div>
      <div slot="dropdown" class="select-options-swapper">
        <template v-if="!optionsEmpty">
          <template v-if="finalOptions && finalOptions.length > maxShowNumber">
            <div
              class="select-options-up"
              v-if="!isTop"
              @mouseenter="handleTopStart"
              @mouseleave="handleTopEnd"
            >
              <div class="select-options-up-arrow"></div>
            </div>
            <div
              class="select-options-bottom"
              v-if="!isBottom"
              @mouseenter="handleBottomStart"
              @mouseleave="handleBottomEnd"
            >
              <div class="select-options-bottom-arrow"></div>
            </div>
          </template>
          <div
            ref="itemList"
            class="select-options-list"
            :style="{
              'max-height': maxShowNumber * itemHeight + 'px',
              width: `${dropdownWidth || currentWidth}px`
            }"
            @scroll="handleScroll"
          >
            <template v-for="(option, index) in finalOptions">
              <!-- 普通option -->
              <SelectItem
                :key="getValue(option)"
                ref="selectItems"
                v-if="!option.options"
                :size="size"
                :selected="
                  selectedOptions.includes(option) ||
                    selectedOptions
                      .map(item => getValue(item))
                      .includes(getValue(option))
                "
                :multiple="multiple"
                :index="index"
                :splitLine="splitLine"
                :extendDirection="extendDirection"
                :option="option"
                @click="onSelect"
                :boundariesSelector="boundariesSelector"
                @mouseenter.native="handleMouseEnter(index)"
                @multiShow="handleMultiShow"
                @multiHide="$emit('multiHide')"
              >
                <slot :data="option"></slot>
              </SelectItem>
              <div :key="getValue(option)" v-else>
                <div class="select-item select-category" :title="option.label">
                  {{ option.label }}
                </div>
                <SelectItem
                  ref="selectItems"
                  v-for="(groupOption, groupIndex) in option.options"
                  :index="groupIndex"
                  :splitLine="splitLine"
                  :key="groupOption.value"
                  :size="size"
                  :selected="
                    selectedOptions.includes(groupOption) ||
                      selectedOptions
                        .map(item => getValue(item))
                        .includes(groupOption.value)
                  "
                  :multiple="multiple"
                  :extendDirection="extendDirection"
                  :option="groupOption"
                  @click="onSelect"
                  :boundariesSelector="boundariesSelector"
                  @multiShow="handleMultiShow"
                  @multiHide="$emit('multiHide')"
                >
                </SelectItem>
                <div
                  v-if="options && index < options.length - 1"
                  class="select-item select-line"
                ></div>
              </div>
            </template>
          </div>
        </template>
        <div
          v-else
          class="select-options-empty"
          :style="{ width: `${dropdownWidth || currentWidth}px` }"
        >
          <SjBlank></SjBlank>
        </div>
      </div>
    </sj-dropdown>
  </div>
</template>

<script>
/**
 * select组件用于替换浏览器原生的下拉框组件
 * 参考Element的select功能
 */
import isequal from "lodash.isequal";
import sizeMixin from "../../../utils/sizeMixin";
import SelectItem from "./SelectItem";
import { getDefaultProp } from "../../../utils";

export default {
  name: "SjSelect",
  mixins: [sizeMixin],
  data() {
    return {
      /**
       * 是否展开
       */
      toggled: false,
      // 单选是否hover
      isHovering: false,

      selectedOptions: [],

      filterWord: "",

      isTop: true,
      topIndex: 0,
      isBottom: false,
      bottomIndex: 0,

      currentWidth: 0,

      /**
       * select的特殊popperjs arrow配置
       */
      arrow: {
        enabled: true,
        fn: (data, options) => {
          data.arrowElement = data.instance.popper.querySelector(
            options.element
          );
          data.offsets.arrow = {
            left: 20,
            top: ""
          };
          data.offsets.popper.top += (data.flipped ? -1 : 1) * this.getOffset;
          return data;
        }
      }
    };
  },
  props: {
    value: {},
    "value-key": String,
    options: {
      type: Array
    },
    type: {
      type: String,
      validator(v) {
        return ["grey3", "highlight", "available", "shadow"].indexOf(v) !== -1;
      },
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.Select?.type,
          "grey3"
        );
      }
    },
    border: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.Select?.clearable,
          false
        );
      }
    },
    filterMethod: Function,
    disabled: {
      type: Boolean,
      default: false
    },
    maxShowNumber: {
      type: Number,
      default: 5
    },
    itemHeight: {
      type: Number,
      default: 30
    },
    dropdownWidth: {
      type: Number
    },
    padding: {
      type: Number,
      default: 10
    },
    splitLine: {
      type: Boolean,
      default: false
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    colorNormal: {
      type: Boolean,
      default: false
    },
    extendDirection: {
      type: String,
      default: "right",
      validator(v) {
        return ["left", "right"].indexOf(v) !== -1;
      }
    },
    trigger: {
      type: String,
      default: "click"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    boundariesSelector: {
      type: String,
      default: "body"
    },
    arrowVisible: {
      type: Boolean,
      default() {
        return getDefaultProp(
          this.$SJ_COMPONENTS_CONFIG?.Select?.arrowVisible,
          true
        );
      }
    }
  },
  computed: {
    finalOptions() {
      const { filterable, filterMethod, filterWord } = this;
      if (filterable) {
        if (filterMethod) {
          return this.options.filter(v => filterMethod(filterWord, v));
        }
        const reg = new RegExp(filterWord, "i");
        return this.options.filter(v => reg.test(v.label));
      }
      return this.options;
    },
    optionsEmpty() {
      const { finalOptions } = this;
      return !Array.isArray(finalOptions) || finalOptions.length === 0;
    },
    /**
     * 不同尺寸的select，dropdown需要一定程度偏移
     */
    getOffset() {
      switch (this.size) {
        // case "small":
        //   return 0;
        // case "middle":
        //   return 0;
        // case "large":
        //   return 2;
        default:
          return 0;
      }
    },
    showClear() {
      const { isHovering, clearable, disabled, selectedOptions } = this;
      if (
        clearable &&
        !disabled &&
        isHovering &&
        selectedOptions &&
        selectedOptions.length
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleScroll() {
      this.judgeSroll();
    },
    handleMousedown() {
      this.$refs.sjInput.focus();
    },
    initSelectedOptions() {
      const { value } = this;
      /**
       * 当option有多层时，做flat操作以确定初始值
       */
      let val;
      if (!this.multiple) {
        val = value === null || value === undefined ? [] : [value];
      } else {
        val = value;
      }
      const opts = [];
      if (this.options && this.options.length) {
        this.options.forEach(item => {
          this.pushOpts(opts, item);
        });
      }

      this.selectedOptions = val.map(v => {
        return (
          opts.find(item => this.getValue(item) === v) || {
            label: v,
            value: v
          }
        );
      });
    },
    judgeSroll() {
      const { maxShowNumber, itemHeight } = this;
      this.isTop = false;
      this.isBottom = false;
      if (this.$refs.itemList) {
        const { scrollTop, scrollHeight } = this.$refs.itemList;
        if (scrollTop === 0) {
          this.isTop = true;
        } else if (maxShowNumber * itemHeight + scrollTop === scrollHeight) {
          this.isBottom = true;
        }
      }
    },
    scrollToTop() {
      if (this.$refs.itemList) {
        this.$refs.itemList.scrollTop = 0;
        this.isTop = true;
        this.isBottom = false;
      }
    },
    handleTopStart() {
      this.handleTopEnd();
      const { topIndex } = this;
      const loopFn = () => {
        if (topIndex === this.topIndex && this.$refs.itemList) {
          const { scrollTop } = this.$refs.itemList;
          if (scrollTop > 0) {
            this.$refs.itemList.scrollTop = scrollTop - 2;
            setTimeout(loopFn, 50);
          }
          this.judgeSroll();
        }
      };
      setTimeout(loopFn, 50);
    },
    handleTopEnd() {
      this.topIndex += 1;
    },
    handleBottomStart() {
      this.handleBottomEnd();
      const { bottomIndex, maxShowNumber, itemHeight } = this;
      const loopFn = () => {
        if (bottomIndex === this.bottomIndex && this.$refs.itemList) {
          const { scrollTop, scrollHeight } = this.$refs.itemList;
          if (maxShowNumber * itemHeight + scrollTop < scrollHeight) {
            this.$refs.itemList.scrollTop = scrollTop + 2;
            setTimeout(loopFn, 50);
          }
          this.judgeSroll();
        }
      };
      setTimeout(loopFn, 50);
    },
    handleBottomEnd() {
      this.bottomIndex += 1;
    },
    handleMultiShow(dropdown) {
      this.$emit("multiShow", dropdown);
    },
    handleKeyupEnter(e) {
      this.$emit("inputEnter", e);
    },
    // for controlling clear icon display
    handleInputEnter() {
      this.isHovering = true;
    },
    handleInputLeave() {
      this.isHovering = false;
    },
    handleOpen() {
      this.$refs.sjInput.focus();
    },
    handleClear(e) {
      const { showClear } = this;
      if (showClear) {
        e.stopPropagation();
        this.selectedOptions = [];
        this.close();
        this.$refs.dropdown.doClose();
      }
    },
    /**
     * 显示dropdown时使其与select input宽度一致
     */
    handleDropdownShow() {
      this.toggled = true;
      this.filterWord = "";
      if (!this.dropdownWidth) {
        this.currentWidth =
          this.$el.querySelector(".select-input").getBoundingClientRect()
            .width - 2;
      }
      this.$emit("dropdownShow");
    },

    handleDropdownHide() {
      this.toggled = false;
      this.$emit("dropdownHide");
    },

    handleMouseEnter(selfIndex) {
      this.$refs.selectItems.forEach((v, i) => {
        if (i === selfIndex) return;
        v.close();
      });
    },
    close() {
      if (!this.$refs.selectItems) return;
      this.$refs.selectItems.forEach(v => {
        v.close();
      });
    },

    /**
     * 根据选中的option获取实际值
     */
    getValue(item) {
      if (item === undefined || item === null) return null;
      if (this.valueKey) {
        return item.value[this.valueKey];
      }
      return item.value;
    },
    /**
     * 单选或多选的相应方法
     * @param {object} item - 选中的option项
     */
    onSelect(e, item) {
      if (item.disabled) {
        if (e) {
          e.stopPropagation();
        }
        return;
      }
      if (!this.multiple) {
        this.selectedOptions = [item];
        this.close();
        this.$refs.dropdown.$refs.popper.doToggle();
      } else {
        if (e) {
          e.stopPropagation();
        }
        const index = this.selectedOptions.indexOf(item);
        if (index >= 0) {
          this.selectedOptions = [
            ...this.selectedOptions.slice(0, index),
            ...this.selectedOptions.slice(index + 1)
          ];
        } else {
          this.selectedOptions = [...this.selectedOptions, item];
        }
      }
      this.$emit("select", this.getValue(item));
      this.$nextTick(() => {
        this.$refs.sjInput.focus();
      });
    },
    /**
     * 多选关闭标签视为对标签的取消选择
     */
    onMultiTagClose(index) {
      const option = this.selectedOptions[index];
      this.selectedOptions = this.selectedOptions.slice(0);
      this.selectedOptions.splice(index, 1);
      this.$emit("select", this.getValue(option));
    },
    pushOpts(opts, item) {
      if (item.options) {
        opts.push(...item.options);
      } else {
        opts.push(item);
        if (item.children) {
          item.children.forEach(v => {
            this.pushOpts(opts, v);
          });
        }
      }
    },
    handleFilterInput(text) {
      if (this.filterable) {
        this.filterWord = text;
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.initSelectedOptions();
      }
    },

    selectedOptions: {
      handler(options, oldOptions) {
        // if (options.length === oldOptions.length) {
        //   if (options.every((d, i) => d === oldOptions[i])) {
        //     return;
        //   }
        // }
        if (isequal(options, oldOptions)) {
          return;
        }
        let value = null;
        if (this.multiple) {
          value = options.map(option => this.getValue(option));
        } else if (options && options.length > 0) {
          value = this.getValue(options[0]);
        }
        if (!isequal(value, this.value)) {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      }
    },

    options: {
      immediate: true,
      deep: true,
      handler() {
        this.initSelectedOptions();
        this.scrollToTop();
      }
    }
  },
  components: {
    SelectItem
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@--select-font-tiny: 10px;
@--select-font-small: 12px;
@--select-font-base: 14px;

@--select-selection-background-color: @color-gray-2;
@--select-category-font-color: @color-normal;
@--select-selection-font-color: @color-highlight;
@--select-selection-font-weight: @regular-weight;
@--select-line-color: @color-gray-2;

.select-item-value {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.select_grey3 {
  /deep/ .sj-input {
    border-color: @color-gray-3!important;
    color: @color-dark;
    &:hover {
      border-color: @color-highlight!important;
    }
    &:focus {
      color: @color-dark;
      border-color: @color-highlight!important;
    }
  }

  .select-arrow2 {
    color: @color-normal;
  }

  &.sj-dropdown {
    border-color: @color-highlight!important;

    & > .popper__arrow {
      border-bottom-color: @color-highlight!important;
      border-top-color: @color-highlight!important;
    }

    .select-options-selected {
      background-color: transparent;
      color: @color-highlight!important;

      & + .select-options-splitLine {
        &::before {
          height: 1px;
        }
      }

      &.select-options-splitLine {
        &::before {
          height: 1px;
        }
      }
    }

    .select-options {
      &:hover {
        background-color: transparent;
      }
    }

    .select-item {
      &:hover {
        & + .select-options-splitLine {
          &::before {
            height: 1px;
          }
        }
      }
    }

    .select-options-splitLine {
      &:hover {
        &::before {
          height: 1px;
        }
      }
    }
  }
}

.select_highlight {
  /deep/ .sj-input {
    border-color: @color-productlight!important;
    color: @color-normal;
    &:hover {
      border-color: @color-highlight!important;
    }
    &:focus {
      color: @color-normal;
      border-color: @color-highlight!important;
    }
  }

  .select-arrow2 {
    color: @color-normal;
  }

  &.sj-dropdown {
    border-color: @color-highlight!important;

    & > .popper__arrow {
      border-bottom-color: @color-highlight!important;
      border-top-color: @color-highlight!important;
    }

    .select-options-selected {
      background-color: transparent;
      color: @color-highlight!important;

      & + .select-options-splitLine {
        &::before {
          height: 1px;
        }
      }

      &.select-options-splitLine {
        &::before {
          height: 1px;
        }
      }
    }

    .select-options {
      &:hover {
        background-color: transparent;
      }
    }

    .select-item {
      &:hover {
        & + .select-options-splitLine {
          &::before {
            height: 1px;
          }
        }
      }
    }

    .select-options-splitLine {
      &:hover {
        &::before {
          height: 1px;
        }
      }
    }
  }
}

.select_available {
  /deep/ .sj-input {
    border-color: transparent !important;
    background-color: @color-gray-1;
    color: @color-available;
    &:hover {
      border-color: @color-available!important;
    }
    &:focus {
      color: @color-available;
      border-color: @color-available!important;
    }
  }

  .select-arrow2 {
    color: @color-available;
  }

  &.sj-dropdown {
    border-color: @color-available!important;

    & > .popper__arrow {
      border-bottom-color: @color-available!important;
      border-top-color: @color-available!important;
    }

    .select-item {
      color: @color-available;
    }

    .select-options-selected {
      color: @color-available!important;
    }

    .select-options {
      &:hover {
        color: @color-available;
      }
    }
  }
}

.select_shadow {
  /deep/ .sj-input {
    border-color: transparent !important;
    background-color: @color-antibg;
    color: @color-available;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03);
    &:hover {
      border-color: @color-available!important;
    }
    &:focus {
      color: @color-available;
      border-color: @color-available!important;
    }
  }

  .select-arrow2 {
    color: @color-available;
  }

  &.sj-dropdown {
    border-color: @color-gray-3!important;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03);

    & > .popper__arrow {
      border-bottom-color: @color-gray-3!important;
      border-top-color: @color-gray-3!important;
    }

    .select-item {
      color: @color-available;
    }

    .select-options-selected {
      color: @color-available!important;
    }

    .select-options {
      &:hover {
        color: @color-available;
      }
    }
  }
}

.select_color_normal {
  &.sj-dropdown {
    .select-item {
      color: @color-normal;
    }
  }
}

.select-arrow {
  display: inline-block;
  transition: transform 0.3s;
}
.select-arrow2 {
  position: absolute;
  right: 5px;
  top: 50%;
  display: inline-block;
  transition: transform 0.3s;

  &.disabled {
    color: @color-light;
  }
}
each(@sizes, {
  &.select-size-@{value} {
    @size: "@{value}-size";
    .select-arrow2 {
      .icon_size(@value);
    }
  }
});


.select-close-icon {
  cursor: pointer;
  .text("tiny", "normal", "semibold");
  right: 32px;
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  transform: scale(0.666);
}

.select-arrow-hide {
  transform: translatey(-50%) scale(0.8) rotate(0);
}

.select-arrow-show {
  transform: translatey(-50%) scale(0.8) rotate(-180deg);
}

.select-input {
  display: flex;
  position: relative;
  .select-input-inner {
    padding-right: 30px !important;

    &.showClear {
      padding-right: 60px !important;
    }

    .text-ellipsis();
  }
}

.select-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: not-allowed;
}
.select-value {
  width: 180px;
  border: 1px solid #d8d8d8;
}

.select-tag-list {
  position: absolute;
  left: 0;
  right: 30px;
  height: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  &:hover{
    overflow-x: auto;
  }

  .select-tag-item {
    margin-left: 3px;
    color: @color-available !important;
    background-color: @color-productlight !important;
    flex-shrink: 0;
  }
}

.select-options {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.select-options-swapper {
  position: relative;
  padding: 6px 0;

  .select-options-up {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    .select-options-up-arrow {
      width: 0;
      border-width: 3px;
      margin-bottom: 3px;
      border-style: solid;
      border-color: transparent transparent @color-normal transparent;
    }

    &:hover {
      background-color: @color-gray-2;
    }
  }

  .select-options-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    .select-options-bottom-arrow {
      width: 0;
      border-width: 3px;
      margin-top: 3px;
      border-style: solid;
      border-color: @color-normal transparent transparent transparent;
    }

    &:hover {
      background-color: @color-gray-2;
    }
  }

  .select-options-list {
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .select-options-empty {
    height: 150px;
  }
}

.select-item {
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  user-select: none;
}

.select-options:hover {
  cursor: pointer;
  background-color: @--select-selection-background-color;
}

// .select-options-small {
//   padding: 6px 16px;
//   font-size: @--select-font-small;
// }

// .select-options-middle {
//   padding: 8px 16px;
//   font-size: @--select-font-base;
// }

// .select-options-large {
//   padding: 10px 16px;
//   font-size: @--select-font-base;
// }

.select-category {
  padding: 4px 12px;
}

// .select-category-small {
//   color: @--select-category-font-color;
//   padding: 6px 16px;
//   font-size: @--select-font-small;
//   transform: scale(0.83);
//   transform-origin: left center;
// }

// .select-category-middle {
//   color: @--select-category-font-color;
//   padding: 8px 16px;
//   font-size: @--select-font-small;
// }

// .select-category-large {
//   color: @--select-category-font-color;
//   padding: 10px 16px;
//   font-size: @--select-font-small;
// }

.select-line {
  padding: 4px 12px;

  &::after {
    content: " ";
    display: block;
    width: 100%;
    height: 1px;
    background-color: @--select-line-color;
  }
}

// .select-line-small {
//   padding: 6px 16px;
// }

// .select-line-middle {
//   padding: 8px 16px;
// }

// .select-line-large {
//   padding: 10px 16px;
// }

.select-options-selected {
  background-color: @--select-selection-background-color;
  color: @--select-selection-font-color;
  font-weight: @--select-selection-font-weight;
}
.icon-icon_info {
  .text("body", "subinfo");
  line-height: 14px;
}
</style>
